import { Box, styled } from '@mui/material';
import { chromeYellow } from '../../../../../../../../utils/colors';

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  gap: 4,
  '&:hover': {
    '&.inactive': {
      '& > .MuiButtonBase-root': {
        display: 'block',
      },
      '& a': {
        marginLeft: 0,
      },
    },
  },
  '&.inactive': {
    '& > .MuiButtonBase-root': {
      display: 'none',
    },
    '& a': {
      marginLeft: 24,
    },
  },
  '& > .MuiButtonBase-root': {
    '& svg': {
      display: 'block',
      fontSize: 20,
      color: chromeYellow[500],
    },
  },
}));

export default StyledBox;
